import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import cx from 'classnames';
import Accordion from 'components/common/controls/Accordion';
import LoanPurposeItem from 'components/Credit24/LoanApplication/LoanPurposeAU/LoanPurposeItem';
import { isMobile } from 'utils/helpers';
import { useApplicationFlags } from 'hooks/useApplicationFlags';

const propTypes = {
  purposes: PropTypes.array.isRequired,
  selectedPurposes: PropTypes.object.isRequired,
  validate: PropTypes.func.isRequired,
  onLoanPurposeChange: PropTypes.func.isRequired,
};

const LoanPurposeAU = (props) => {
  const { selectedPurposes, onLoanPurposeChange } = props;
  const selectedPurposesKeys = Object.keys(selectedPurposes);
  const { isOcmOrUpgrade } = useApplicationFlags();

  const maxPurposesAvailable = isOcmOrUpgrade ? 3 : 2;
  const arePurposesEnabled = selectedPurposesKeys.length < maxPurposesAvailable;
  const descriptionTextId = isOcmOrUpgrade ? 'loan_purpose.upgrade.description' : 'loan_purpose.description';
  const errorTextId = isOcmOrUpgrade ? 'loan_purpose.upgrade.error' : 'loan_purpose.error';

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id="loan_purpose.title" />
      </h1>
      <div className="loan-form__step-body">
        <h3 className="loan-form__step-subtitle">
          <FormattedMessage id="loan_purpose.subtitle" />
        </h3>
        <Field
          name="selectedPurposes"
          component={
            ({ meta: { error, touched } }) => (
              <h2 className={cx({ 'txt-error': error && touched })}>
                {error && touched
                  ? <FormattedMessage id={errorTextId} />
                  : <FormattedMessage id={descriptionTextId} />}
              </h2>
            )
          }
          validate={props.validate}
        />
        <p>
          {selectedPurposesKeys.map((subPurpose) => (
            <Field
              key={subPurpose}
              name={subPurpose}
              component={LoanPurposeItem}
              shortText={selectedPurposes[subPurpose]}
              onChange={onLoanPurposeChange}
              mod="selected"
            />
          ))}
        </p>
        <div className="grid grid--narrow">
          {props.purposes.map((purpose) => {
            const loanPurposeGroup = (
              <p className="loan-purpose-group">
                {purpose.purposes.map((subPurpose) => {
                  const purposeName = `loanPurposes.${subPurpose.id}`;
                  return (
                    <Field
                      className="loan-purpose-group__item"
                      key={purposeName}
                      name={purposeName}
                      component={LoanPurposeItem}
                      shortText={subPurpose.name}
                      fullText={`${purpose.category} - ${subPurpose.name}`}
                      onChange={onLoanPurposeChange}
                      disabled={
                        !arePurposesEnabled && !selectedPurposesKeys.includes(purposeName)
                      }
                    />
                  );
                })}
              </p>
            );
            return (
              <div className="grid__item one-half palm-one-whole" key={purpose.category}>
                <Accordion
                  title={purpose.category}
                  mod="loan-purpose"
                  defaultOpened={isMobile}
                >
                  {loanPurposeGroup}
                </Accordion>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

LoanPurposeAU.propTypes = propTypes;

export default LoanPurposeAU;
